import { Modal, useModal } from '@components/modal';
import { Text } from '@components/text';
import { styledTranslate, useScopedTranslate } from '@locale/translate';

import { useAuthenticatedUser } from 'features/authentication/authentication-provider';

export const useGatheringExportDataModal = () =>
  useModal(GatheringExportDataModal, { variant: 'REGULAR' });

const GatheringExportDataModal = () => {
  const { t } = useScopedTranslate(locale);
  const me = useAuthenticatedUser();

  return (
    <Modal>
      <Modal.SimpleHeader title={t('gatheringData')} />
      <Modal.Content>
        <Text
          text={styledTranslate({
            key: 'modalText',
            variables: {
              email: {
                text: me.email,
                color: 'blue100',
              },
            },
            translations: locale,
          })}
        />
      </Modal.Content>
    </Modal>
  );
};

export const locale = {
  en: {
    gatheringData: 'Gathering data',
    modalText:
      "Your file is being processed and will be sent to your email address: {email} once it is ready. \n\nThis may take a few minutes. \nIf you don't see it in your inbox, please check your spam folder.",
    close: 'Close',
  },
  is: {
    gatheringData: 'Undirbúningur útflutnings',
    modalText:
      'Skjalið er í vinnslu og verður sent á netfangið þitt: {email} þegar það er tilbúið. \n\nÞetta gæti tekið nokkrar mínútur. \nEf þú finnur það ekki í pósthólfinu, vinsamlegast athugaðu ruslpósthólfið.',
    close: 'Loka',
  },
};
